"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveySelectionTypeToJSON = exports.SurveySelectionTypeFromJSONTyped = exports.SurveySelectionTypeFromJSON = exports.SurveySelectionType = void 0;
/**
 *
 * @export
 */
exports.SurveySelectionType = {
    SingleSelect: 'SINGLE_SELECT',
    MultiSelect: 'MULTI_SELECT',
    Unknown: 'UNKNOWN'
};
function SurveySelectionTypeFromJSON(json) {
    return SurveySelectionTypeFromJSONTyped(json, false);
}
exports.SurveySelectionTypeFromJSON = SurveySelectionTypeFromJSON;
function SurveySelectionTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.SurveySelectionTypeFromJSONTyped = SurveySelectionTypeFromJSONTyped;
function SurveySelectionTypeToJSON(value) {
    return value;
}
exports.SurveySelectionTypeToJSON = SurveySelectionTypeToJSON;
